import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

export default function ComingSoon() {
  return (
    <Box>
      <Typography fontSize={50}>Coming Soon...</Typography>
    </Box>
  );
}
